import { EventBus } from '@/common/eventBus';
import { getQueryString } from '@/common/url';
import { ParentEventData } from './types';

export const platform = getQueryString('platform') || 'wap'; // wap, web, app
export const version = getQueryString('version') || 0; // For old implementation on Sportybet side (float button was handled on Sportybet side)
export const SPORTY_DESK = 'SPORTY_DESK';
export const SPORTY_BET = 'SPORTY_BET';

const availableAndroidReceiveEvents = ['APP_HAS_VOICE_PERMISSION', 'START_CALL'];
const availableBrowserReceiveEvents = ['OPEN', 'TOKEN', 'CALLPARENTAPI'];
export const availableReceiveEvents = [
  'INIT',
  'CUSTOMISATION_UPDATE',
  'LOGIN',
  'LOGIN_POP',
  'GO_LIVE_CHAT',
  // Web/WAP only: responses for new auth + SB API proxy flow
  // Some hosts respond with TOKEN { value }
  'TOKEN',
  'CALLPARENTAPI',
  ...availableAndroidReceiveEvents,
  ...availableBrowserReceiveEvents,
];

export const listenFromParent = <T extends any = any>(eventType: string, callback: (data: T) => void = () => {}) => {
  let runnable: Function | null = callback;
  switch (platform) {
    case 'wap':
    case 'web':
      const listener = function (msg: MessageEvent) {
        const msgInfo = <ParentEventData>msg.data;
        if (
          msgInfo.appName !== SPORTY_BET ||
          !availableReceiveEvents.includes(msgInfo.eventType) ||
          msgInfo.eventType !== eventType
        )
          return;
        runnable?.(msgInfo.data);
      };
      window.addEventListener('message', listener);
      return () => {
        window.removeEventListener('message', listener);
        runnable = null;
      };
    case 'app':
    case 'ios':
      const event = `Bridge_${eventType}`;
      const eventListener = (info: any) => {
        const jsonInfo = JSON.parse(info);
        runnable?.(jsonInfo.data);
      };
      EventBus.$on(event, eventListener);
      return () => {
        EventBus.$off(event, eventListener);
      };
    default:
  }
  return () => {
    runnable = null;
  };
};
